import { render, staticRenderFns } from "./news-outlist.vue?vue&type=template&id=9f1f94a8&scoped=true&"
import script from "./news-outlist.vue?vue&type=script&lang=js&"
export * from "./news-outlist.vue?vue&type=script&lang=js&"
import style0 from "./news-outlist.vue?vue&type=style&index=0&id=9f1f94a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1f94a8",
  null
  
)

export default component.exports